import { faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@mui/material';
import styled from 'styled-components';

const Input = styled.input`
  ::-webkit-file-upload-button {
    cursor: pointer;
  }
`;

export const MediaDropbox = ({
  onChange,
  type = 'image',
  icon = faCloudUploadAlt,
  children,
  short,
  inputRef,
  hasError,
  ...rest
}: {
  hasError?: boolean;
  onChange;
  type;
  icon;
  children;
  short?;
  inputRef;
}) => {
  return (
    <div
      className="h-full w-full relative rounded-lg flex flex-grow justify-center items-center cursor-pointer"
      style={{ border: `2px solid ${hasError ? 'red' : 'transparent'}` }}
    >
      <Input
        className="h-full w-full flex-grow absolute cursor-pointer opacity-0"
        type="file"
        accept={type === 'image' ? 'image/*' : 'video/*'}
        onChange={(evt) => {
          onChange(evt.target.files?.[0]);
          evt.target.value = '';
        }}
        ref={inputRef}
        {...rest}
      />
      <div
        className={`flex ${
          short ? 'flex-row' : 'flex-col'
        } items-center leading-normal p-2.5`}
      >
        <FontAwesomeIcon icon={icon} className="text-2xl text-[#C5C8D2]" />
        <Typography
          variant="h1"
          className={`font-semibold ${
            short ? 'ml-[15px]' : 'mt-4'
          } mb-0 text-[16px] text-center text-gray-1`}
        >
          Drop or <span className="text-primary">browse</span>
        </Typography>
        <div className="mt-4">{children}</div>
      </div>
    </div>
  );
};
